<template>
  <div>
    <div class="header">
      <div class="search" style="search-select;">
        <el-select
          v-model="searchHouseId"
          filterable
          placeholder="请选择楼盘"
          style="margin: 0 10px"
        >
          <el-option label="全部预告" value="all"></el-option>
          <el-option
            v-for="item in houseData"
            :key="item.houseId"
            :label="item.houseName"
            :value="item.houseId"
          ></el-option>
        </el-select>
        <el-select
          v-model="userId"
          filterable
          placeholder="请选择主播"
          style="margin: 0 10px"
        >
          <el-option label="全部主播" value="all"></el-option>
          <el-option
            v-for="item in anchorData"
            :key="item.userId"
            :label="handledecrypt(item.userInfo && item.userInfo.nickName)"
            :value="item.userId"
          ></el-option>
        </el-select>
        <el-select
          v-model="liveStatus"
          filterable
          placeholder="请选择直播状态"
          style="margin: 0 10px"
        >
          <el-option label="全部状态" value="all"></el-option>
          <el-option
            v-for="item in statusList"
            :key="item.statusValue"
            :label="item.statusValue"
            :value="item.statusValue"
          ></el-option>
        </el-select>
        <el-button icon="el-icon-search" size="small" @click="onSearch"
          >查询</el-button
        >
        <el-button icon="el-icon-refresh" size="small" @click="onRefresh"
          >刷新</el-button
        >
      </div>
      <div>
        <el-button-group>
          <PermissionsBtn
            :icon="'el-icon-download'"
            :btnType="'primary'"
            :permissionName="'_Export'"
            :downloadUrl="'/live/LiveAdvanceNotice/downLoad'"
            :checkList="checkList"
            :form="{
              houseId: this.houseId,
              userId: this.userId,
              liveStatus: this.liveStatus,
            }"
          ></PermissionsBtn>
          <el-button
            style="margin: 0 10px"
            type="primary"
            icon="el-icon-plus"
            @click="onAdd"
            v-if="roleList[path].includes('_Add')"
            >新增</el-button
          >
          <el-button
            type="danger"
            icon="el-icon-delete"
            @click="onRemove"
            v-if="roleList[path].includes('_Delete')"
            >批量删除</el-button
          >
        </el-button-group>
      </div>
    </div>

    <el-table
      v-loading="listLoading"
      height="700"
      :data="tableData"
      element-loading-text="loading"
      border
      fit
      highlight-current-row
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column align="center" width="50" label="编号">
        <template slot-scope="scope">{{ scope.$index + 1 }}</template>
      </el-table-column>

      <el-table-column align="center" label="预告标题">
        <template slot-scope="scope">{{ scope.row.title }}</template>
      </el-table-column>

      <el-table-column align="center" label="预告图片">
        <template slot-scope="scope">
          <img :src="scope.row.photo" style="width: 100%" />
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        width="200"
        label="预告正文"
        show-overflow-tooltip
      >
        <template slot-scope="scope">{{ scope.row.introduce }}</template>
      </el-table-column>
      <el-table-column align="center" label="预告备注">
        <template slot-scope="scope">{{ scope.row.remark }}</template>
      </el-table-column>
      <el-table-column align="center" label="直播楼盘">
        <template slot-scope="scope">{{ scope.row.houseName }}</template>
      </el-table-column>
      <el-table-column align="center" label="直播时间">
        <template slot-scope="scope">{{ scope.row.liveTime }}</template>
      </el-table-column>
      <el-table-column align="center" label="主播">
        <template slot-scope="scope">{{
          handledecrypt(scope.row.nickName)
        }}</template>
      </el-table-column>
      <el-table-column align="center" label="管理员">
        <template slot-scope="scope">
          <div v-if="scope.row.adminInfos">
            <span
              v-for="(item, idx) in scope.row.adminInfos"
              :key="(item && item.userId) || idx"
              >{{ handledecrypt(item && item.nickName) }}<br
            /></span>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" width="150" label="预告状态">
        <template slot-scope="scope">
          <el-select v-model="scope.row.status" placeholder="请选择" disabled>
            <el-option
              v-for="item in statusList"
              :key="item.status"
              :label="item.statusValue"
              :id="item.status"
              :value="item.status"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column align="center" label="访问人数">
        <template slot-scope="scope">{{ scope.row.visitsCount }}</template>
      </el-table-column>
      <el-table-column
        align="center"
        label="回放地址"
        width="150"
        show-overflow-tooltip
      >
        ">
        <template slot-scope="scope">{{ scope.row.playbackAddress }}</template>
      </el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="mini"
            @click="edit(scope)"
            v-if="roleList[path].includes('_Update')"
            >编辑</el-button
          >
          <el-button
            type="text"
            size="mini"
            @click="deleteAdvanceNotice(scope)"
            v-if="roleList[path].includes('_Delete')"
            >删除</el-button
          >

          <el-button type="text" size="mini" @click="toNews(scope)"
            >查看动态</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <Pagination ref="Pagination" />

    <editForm ref="editForm" />
    <liveNews ref="liveNews" />
  </div>
</template>

<script>
const editForm = () => import('./editForm');
import LiveNews from './liveNews';
import Pagination from '@/components/Pagination';
import { getToken } from '@/utils/token';
import {
  getAdvanceNoticeList,
  getAllAnchors,
  getAdvanceNotice,
  removeAdvanceNotice,
} from '@/api/live.js';
import { houseList } from '@/api/houseApi.js';
import { mapGetters } from 'vuex';
import { decrypt } from '@/utils/encryp';

export default {
  components: {
    Pagination,
    editForm,
    LiveNews,
  },
  inject: ['reload'],
  created() {
    const arr = this.$route.path.split('/');
    this.path = arr[arr.length - 1];
  },
  mounted() {
    this.getList();
  },
  data() {
    return {
      listLoading: false,
      tableData: [],
      userId: '',
      houseId: JSON.parse(getToken('userInfo')).houseId,
      searchHouseId: '',
      liveStatus: '',
      pageIndex: 1,
      pageSize: 10,
      multipleSelection: [],
      houseData: [],
      anchorData: [],
      selectValue: '',
      selectLabel: '',
      path: '',
      statusList: [
        {
          status: 0,
          statusValue: '即将开始',
        },
        {
          status: 1,
          statusValue: '直播中',
        },
        {
          status: 2,
          statusValue: '直播结束',
        },
      ],
      checkList: [],
    };
  },
  computed: {
    ...mapGetters(['paginObj', 'roleList']),
  },
  watch: {
    paginObj: 'getList',
  },
  methods: {
    // 处理解密
    handledecrypt(str) {
      if (!str) return;
      return decrypt(str);
    },
    async getList() {
      this.listLoading = true;
      const areaId = localStorage.getItem('areaId')
        ? JSON.parse(localStorage.getItem('areaId')).areaId
        : '';
      await getAdvanceNoticeList({
        houseId: this.houseId,
        userId: this.userId,
        liveStatus: this.liveStatus,
        pageIndex: this.paginObj.pageIndex,
        pageSize: this.paginObj.pageSize,
        areaId,
      }).then((res) => {
        this.listLoading = false;
        if (res.code !== 200 || res.data == null) return;
        this.tableData = res.data.dataList;
        this.pageIndex = res.data.pageIndex;
        this.pageSize = res.data.pageSize;
        this.$refs.Pagination.pageIndex = res.data.pageIndex;
        this.$refs.Pagination.pageSize = res.data.pageSize;
        this.$refs.Pagination.totalCount = res.data.totalCount;
      });
      try {
        houseList({
          areaId: '',
          name: '',
        }).then((res) => {
          this.houseData = res.data.dataList;
        });
      } catch (e) {
        window.console.log(e);
      }
      try {
        getAllAnchors().then((res) => {
          this.anchorData = res.data.listDatas;
          // console.log('主播：', res.data.listDatas);
        });
      } catch (e) {
        window.console.log(e);
      }
    },
    //选中
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.checkList = val.map((item) => {
        return item.userId;
      });
    },
    //搜索
    onSearch() {
      if (this.searchHouseId === 'all') {
        this.houseId = '';
      } else {
        this.houseId = this.searchHouseId;
      }
      if (this.userId === 'all') {
        this.userId = '';
      }
      if (this.liveStatus === 'all') {
        this.liveStatus = '';
      }

      this.getList();
    },
    //刷新
    onRefresh() {
      this.reload();
    },
    //新增
    onAdd() {
      this.$refs.editForm.dialogTitle = '新增直播预告';
      this.$refs.editForm.dialogFormVisible = true;
      this.$refs.editForm.houseData = this.houseData;
      // this.$refs.editForm.anchorList = this.anchorData;
      // console.log('主播列表', this.anchorData);
    },

    //编辑
    async edit(scope) {
      this.$refs.editForm.dialogTitle = '编辑直播预告';
      this.$refs.editForm.dialogFormVisible = true;
      this.$refs.editForm.liveAdvanceNoticeId = scope.row.liveAdvanceNoticeId;
      this.$refs.editForm.houseData = this.houseData;
      // this.$refs.editForm.anchorList = this.anchorData;
      await getAdvanceNotice(scope.row.liveAdvanceNoticeId).then((res) => {
        this.$refs.editForm.editForm = res.data;
        let { userId, nickName, mobile } = scope.row;
        console.log('row', scope.row);
        this.$refs.editForm.anchorList = [
          {
            label: `${nickName}(${mobile})`,
            value: userId,
          },
        ];
        this.$refs.editForm.editForm.userId = userId;
        // anchorList
        let adminOptions = scope.row.adminInfos.map((item) => {
          return {
            label: `${item.nickName}(${item.mobile})`,
            value: item.userId,
          };
        });
        this.$refs.editForm.adminOptions = adminOptions;
        this.$refs.editForm.editForm.adminInfo = adminOptions.map((item) => {
          return item.value;
        });
      });
      // this.$refs.editForm.editForm.adminInfo =
      //   this.$refs.editForm.editForm.adminInfo.split(',');
    },
    //批量删除
    onRemove() {
      let checkIds = [];
      this.multipleSelection.forEach((item) => {
        checkIds.push(item.liveAdvanceNoticeId);
      });
      this.funcRemove(checkIds);
    },
    //单条删除
    deleteAdvanceNotice(scope) {
      let checkIds = [];
      checkIds.push(scope.row.liveAdvanceNoticeId);
      this.funcRemove(checkIds);
    },
    funcRemove: function (checkIds) {
      try {
        if (checkIds.length === 0) {
          return this.$message.error('请选择要删除的数据！');
        }
        this.$confirm('是否狠心删除该数据', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error',
        })
          .then(async () => {
            await removeAdvanceNotice(checkIds).then((res) => {
              if (res.code === 200) {
                this.onRefresh();
                this.$message.success('删除成功!');
              } else {
                this.onRefresh();
                this.$message.info('删除失败：' + res.message);
              }
            });
          })
          .catch(() => {
            this.$message.info('删除出错');
          });
      } catch (e) {
        this.$message.info('删除出错:' + e.message);
        window.console.log(e);
      }
    },
    toNews(scope) {
      let liveAdvanceNoticeId = scope.row.liveAdvanceNoticeId;
      let liveAdvanceNoticeTitle = scope.row.title;
      this.$refs.liveNews.dialogFormVisible = true;
      console.log(liveAdvanceNoticeId, liveAdvanceNoticeTitle, 'test');
      this.$refs.liveNews.liveAdvanceNoticeId = liveAdvanceNoticeId;
      this.$refs.liveNews.liveAdvanceNoticeTitle = liveAdvanceNoticeTitle;
      this.$refs.liveNews.getList();
      // this.$router.push({
      //   path: 'liveNews',
      //   query: { id: liveAdvanceNoticeId, title: liveAdvanceNoticeTitle },
      // });
    },
  },
};
</script>
<style lang="less" scoped>
.el-table {
  width: 100% !important;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  .search {
    display: flex;
    width: 800px;

    .search-input {
      margin: 0 10px;
      width: 300px;
    }

    .search-picker {
      width: 250px;
    }

    .search-select {
      margin-right: 10px;
    }
  }

  button {
    height: 40px;
  }
}
</style>
